import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import { Toaster } from './components/ui/sonner';
import { CartProvider } from './contexts/CartContext';
import HomePage from './pages/HomePage';
import BookingPage from './pages/BookingPage';
import PricingPage from './pages/PricingPage';
import AdminDashboard from './pages/AdminDashboard';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import BookingConfirmed from './pages/BookingConfirmed';
import HomeBloodCollection from './pages/services/HomeBloodCollection';
import AgedCarePathology from './pages/services/AgedCarePathology';
import NDISPathology from './pages/services/NDISPathology';
import CorporatePathology from './pages/services/CorporatePathology';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <CartProvider>
          <div className="App">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/booking" element={<BookingPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/booking-confirmed" element={<BookingConfirmed />} />
              <Route path="/services/home-blood-collection" element={<HomeBloodCollection />} />
              <Route path="/services/aged-care-pathology" element={<AgedCarePathology />} />
              <Route path="/services/ndis-pathology" element={<NDISPathology />} />
              <Route path="/services/corporate-pathology" element={<CorporatePathology />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
            </Routes>
            <Toaster />
          </div>
        </CartProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
